var _circle, _path, _circle2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegzec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 21.26,
    cy: 20.04,
    r: 4.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.56 29.64v-.73c0-2.12-1.72-3.84-3.84-3.84H17.8c-2.12 0-3.84 1.72-3.84 3.84v.73"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 18.66,
    cy: 29.09,
    r: 1.44
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M27.43 7.08h1.76c2.74 0 4.96 2.1 4.96 4.69v23c0 2.59-2.22 4.69-4.96 4.69H13.32c-2.74 0-4.96-2.1-4.96-4.69V11.76c0-2.59 2.22-4.69 4.96-4.69h1.78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M19.79 3.2h2.94v5.03c0 .81-.66 1.47-1.47 1.47-.81 0-1.47-.66-1.47-1.47V3.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegzec);
export default __webpack_public_path__ + "static/media/REGZEC.620b014ac8e81110fbbd6aec0e085591.svg";
export { ForwardRef as ReactComponent };